import React, { Component } from "react";
import axios from "axios";
import LargeLinkedButton from "../components/LargeLinkedButton";
import SmallLinkedButton from "../components/SmallLinkedButton";
import SmallButton from "../components/SmallButton";
import StyledInput from "../components/StyledInput";
import {
  setOrigin,
  setDestination,
  requestTrip,
  lastSearch,
  resetStopRequest,
  setTripDate,
  setTripTime,
  setTripArr,
  setUserPosition,
  resetTripRequest,
  setTrip,
  setTripConfig,
} from "../actions/index";
import { doubleDigits } from "../actions/helper";
import { connect } from "react-redux";
import { StyledH1 } from "../components/Styles";
import {
  CancleCircleIcon,
  LocationAIcon,
  LocationBIcon,
  SettingsIcon,
  SwapIcon,
} from "../icons/Icons";
import LastTrip from "../components/LastTrip";
import { Link } from "react-router-dom";
import { SpinningCircles } from "react-loading-icons";
import "../styles/TripRequest.css";

class TripRequestView extends Component {
  constructor(props) {
    super(props);

    this.lastSearch = null;
    this.timeout = 0;

    this.setOrigin = this.setOrigin.bind(this);
    this.setDestination = this.setDestination.bind(this);
    this.setTripDate = this.setTripDate.bind(this);
    this.setTripTime = this.setTripTime.bind(this);
    this.setTripArr = this.setTripArr.bind(this);
    this.requestTrip = this.requestTrip.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.props.setTrip(null);
    this.props.resetStopRequest();

    let now = new Date();
    let year = now.getFullYear();
    let month = doubleDigits(now.getMonth() + 1);
    let date = doubleDigits(now.getDate());

    this.state = {
      lastTrips: [],
      favoritesTrips: [],
      config: null,
      date: props.dateTrip
        ? props.dateTrip.substring(0, 4) +
          "-" +
          props.dateTrip.substring(4, 6) +
          "-" +
          props.dateTrip.substring(6, 8)
        : year + "-" + month + "-" + date,
      time: props.tripTime ? props.tripTime : null,
    };
  }

  setOrigin(data) {
    this.props.setOrigin(data);
    this.props.resetStopRequest();
    this.saveToLocalStorage(data);
  }

  setDestination(data) {
    this.props.setDestination(data);
    this.props.resetStopRequest();
    this.saveToLocalStorage(data);
  }

  setTripDate(data) {
    if (!data) {
      let now = new Date();
      let year = now.getFullYear();
      let month = doubleDigits(now.getMonth() + 1);
      let date = doubleDigits(now.getDate());
      data = year + "-" + month + "-" + date;
      this.setState({
        date: data,
      });
    }
    this.setState({
      date: data,
    });
    let dateStr = data.replace(/-/g, "");
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.props.setTripDate(dateStr);
      this.props.resetStopRequest();
    }, 300);
  }

  setTripTime(data) {
    if (!data) {
      var now = new Date();
      var hours = doubleDigits(now.getHours());
      var minutes = doubleDigits(now.getMinutes());
      data = hours + ":" + minutes;
      this.setState({
        time: data,
      });
    }
    this.setState({
      time: data,
    });
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.props.setTripTime(data);
      this.props.resetStopRequest();
    }, 300);
  }

  setTripArr(data) {
    this.props.setTripArr(data);
    this.props.resetStopRequest();
  }

  async requestStages(originId, destinationId) {
    await axios.get("/stopFinder/" + originId).then((data) => {
      this.setOrigin(data.data.data[0]);
    });
    await axios.get("/stopFinder/" + destinationId).then((data) => {
      this.setDestination(data.data.data[0]);
    });
    return true;
  }

  getSnapshotBeforeUpdate(prevProps) {
    if (this.props.tripConfig !== this.state.config) {
      this.setConfig();
      this.requestTrip(true);
    }
    return null;
  }

  componentDidUpdate() {}

  async componentDidMount() {
    window.scrollTo(0, 0);
    try {
      if (localStorage.getItem("lastTrips")) {
        this.setState({
          lastTrips: JSON.parse(localStorage.getItem("lastTrips")),
        });
      }

      if (localStorage.getItem("favoritesTrips")) {
        this.setState({
          favoritesTrips: JSON.parse(localStorage.getItem("favoritesTrips")),
        });
      }

      if (localStorage.getItem("tripConfig")) {
        this.props.setTripConfig(
          JSON.parse(localStorage.getItem("tripConfig"))
        );
      }
    } catch (e) {}

    if (this.props.location.search !== "") {
      this.props.setOrigin(null);
      this.props.setDestination(null);
      this.props.resetStopRequest();
      let paramsArr = this.props.location.search
        .slice(1, this.props.location.search.length)
        .split("&");
      let params = [];
      paramsArr.forEach((param) => {
        params.push({
          name: param.split("=")[0],
          value: param.split("=")[1],
        });
      });

      let originId,
        destinationId,
        originType,
        destinationType,
        originName,
        destinationName;
      let date,
        time,
        arr = "dep";
      if (params.length > 0) {
        params.forEach((param) => {
          if (param.name === "name_origin" || param.name === "origin") {
            if (param.name === "name_origin") {
              originType = "station";
            }
            originId = decodeURI(param.value);
          } else if (
            param.name === "name_destination" ||
            param.name === "destination"
          ) {
            if (param.name === "name_destination") {
              destinationType = "station";
            }
            destinationId = decodeURI(param.value);
          } else if (
            param.name === "origin_type" ||
            param.name === "start_typ"
          ) {
            originType = param.value;
          } else if (
            param.name === "destination_type" ||
            param.name === "ziel_typ"
          ) {
            destinationType = param.value;
          } else if (
            param.name === "origin_name" ||
            param.name === "start_name"
          ) {
            originName = decodeURI(param.value);
          } else if (
            param.name === "destination_name" ||
            param.name === "ziel_name"
          ) {
            destinationName = decodeURI(param.value);
          } else if (param.name === "date") {
            date = param.value;
          } else if (param.name === "time" && param.value) {
            time = String(param.value).replace(/%3A/g, ":");
          } else if (param.name === "depArr") {
            arr = param.value;
          }
        });
      }

      if (date) {
        date =
          date.substring(6, 10) +
          "-" +
          date.substring(3, 5) +
          "-" +
          date.substring(0, 2);
        this.props.setTripDate(date.replace(/-/g, ""));
        this.setTripDate(date);
      }
      if (time) {
        this.setTripTime(time);
      }
      this.setTripArr(arr);

      if (originType) {
        if (
          originType === "station" ||
          originType === "any" ||
          originType === "haltestelle"
        ) {
          if (originId) {
            await axios.get("/stopFinder/" + originId).then((data) => {
              if (originName) {
                data.data.data[0].name = originName;
              }
              if (data.data.data[0]) {
                this.setOrigin(data.data.data[0]);
              }
            });
          }
        } else if (originType == "address" || originType == "adresse") {
          if (originId) {
            await axios.get("/stopFinder/" + originId).then((data) => {
              if (originName) {
                data.data.data[0].name = originName
                  .replace(/%20/g, " ")
                  .replace(/\+/g, " ")
                  .replace(/%C3%96/g, "Ö")
                  .replace(/%C3%84/g, "Ä")
                  .replace(/%C3%9C/g, "Ü")
                  .replace(/%C3%B6/g, "ö")
                  .replace(/%C3%A4/g, "ä")
                  .replace(/%C3%BC/g, "ü")
                  .replace(/%C3%9F/g, "ß");
              }
              this.setOrigin(data.data.data[0]);
            });
          }
        } else if (originType == "coord" || originType == "koordinaten") {
          if (originId) {
            await axios
              .get("/stopFinder/coord:" + originId + ":WGS84")
              .then((data) => {
                if (originName) {
                  data.data.data[0].name = originName
                    .replace(/%20/g, " ")
                    .replace(/\+/g, " ")
                    .replace(/%C3%96/g, "Ö")
                    .replace(/%C3%84/g, "Ä")
                    .replace(/%C3%9C/g, "Ü")
                    .replace(/%C3%B6/g, "ö")
                    .replace(/%C3%A4/g, "ä")
                    .replace(/%C3%BC/g, "ü")
                    .replace(/%C3%9F/g, "ß");
                }
                this.setOrigin(data.data.data[0]);
              });
          }
        } else if (originType == "poi") {
          if (originId) {
            await axios.get("/stopFinder/" + originId).then((data) => {
              if (originName) {
                data.data.data[0].name = originName
                  .replace(/%20/g, " ")
                  .replace(/\+/g, " ")
                  .replace(/%C3%96/g, "Ö")
                  .replace(/%C3%84/g, "Ä")
                  .replace(/%C3%9C/g, "Ü")
                  .replace(/%C3%B6/g, "ö")
                  .replace(/%C3%A4/g, "ä")
                  .replace(/%C3%BC/g, "ü")
                  .replace(/%C3%9F/g, "ß");
              }
              this.setOrigin(data.data[0]);
            });
          }
        }
      } else if (originId) {
        await axios
          .get("/stopFinder/coord:" + originId + ":WGS84")
          .then((data) => {
            if (originName) {
              data.data.data[0].name = originName
                .replace(/%20/g, " ")
                .replace(/\+/g, " ")
                .replace(/%C3%96/g, "Ö")
                .replace(/%C3%84/g, "Ä")
                .replace(/%C3%9C/g, "Ü")
                .replace(/%C3%B6/g, "ö")
                .replace(/%C3%A4/g, "ä")
                .replace(/%C3%BC/g, "ü")
                .replace(/%C3%9F/g, "ß");
            }
            this.setOrigin(data.data.data[0]);
          });
      }

      if (destinationType) {
        if (
          destinationType == "station" ||
          destinationType == "any" ||
          destinationType == "haltestelle"
        ) {
          if (destinationId) {
            await axios.get("/stopFinder/" + destinationId).then((data) => {
              if (destinationName) {
                data.data.data[0].name = destinationName
                  .replace(/%20/g, " ")
                  .replace(/\+/g, " ")
                  .replace(/%C3%96/g, "Ö")
                  .replace(/%C3%84/g, "Ä")
                  .replace(/%C3%9C/g, "Ü")
                  .replace(/%C3%B6/g, "ö")
                  .replace(/%C3%A4/g, "ä")
                  .replace(/%C3%BC/g, "ü")
                  .replace(/%C3%9F/g, "ß");
              }
              this.setDestination(data.data.data[0]);
            });
          }
        } else if (
          destinationType == "address" ||
          destinationType == "adresse"
        ) {
          if (destinationId) {
            await axios.get("/stopFinder/" + destinationId).then((data) => {
              if (destinationName) {
                data.data.data[0].name = destinationName
                  .replace(/%20/g, " ")
                  .replace(/\+/g, " ")
                  .replace(/%C3%96/g, "Ö")
                  .replace(/%C3%84/g, "Ä")
                  .replace(/%C3%9C/g, "Ü")
                  .replace(/%C3%B6/g, "ö")
                  .replace(/%C3%A4/g, "ä")
                  .replace(/%C3%BC/g, "ü")
                  .replace(/%C3%9F/g, "ß");
              }
              this.setDestination(data.data.data[0]);
            });
          }
        } else if (
          destinationType == "coord" ||
          destinationType == "koordinaten"
        ) {
          if (destinationId) {
            await axios
              .get("/stopFinder/coord:" + destinationId + ":WGS84")
              .then((data) => {
                if (destinationName) {
                  data.data.data[0].name = destinationName
                    .replace(/%20/g, " ")
                    .replace(/\+/g, " ")
                    .replace(/%C3%96/g, "Ö")
                    .replace(/%C3%84/g, "Ä")
                    .replace(/%C3%9C/g, "Ü")
                    .replace(/%C3%B6/g, "ö")
                    .replace(/%C3%A4/g, "ä")
                    .replace(/%C3%BC/g, "ü")
                    .replace(/%C3%9F/g, "ß");
                }
                this.setDestination(data.data.data[0]);
              });
          }
        } else if (destinationType == "poi") {
          if (destinationId) {
            await axios.get("/stopFinder/" + destinationId).then((data) => {
              if (destinationName) {
                data.data.data[0].name = destinationName
                  .replace(/%20/g, " ")
                  .replace(/\+/g, " ")
                  .replace(/%C3%96/g, "Ö")
                  .replace(/%C3%84/g, "Ä")
                  .replace(/%C3%9C/g, "Ü")
                  .replace(/%C3%B6/g, "ö")
                  .replace(/%C3%A4/g, "ä")
                  .replace(/%C3%BC/g, "ü")
                  .replace(/%C3%9F/g, "ß");
              }
              this.setDestination(data.data.data[0]);
            });
          }
        }
      } else if (destinationId) {
        await axios.get("/stopFinder/" + destinationId).then((data) => {
          if (destinationName) {
            data.data.data[0].name = destinationName
              .replace(/%20/g, " ")
              .replace(/\+/g, " ")
              .replace(/%C3%96/g, "Ö")
              .replace(/%C3%84/g, "Ä")
              .replace(/%C3%9C/g, "Ü")
              .replace(/%C3%B6/g, "ö")
              .replace(/%C3%A4/g, "ä")
              .replace(/%C3%BC/g, "ü")
              .replace(/%C3%9F/g, "ß");
          }
          this.setDestination(data.data.data[0]);
        });
      }

      if (originId && destinationId) {
        this.requestTrip();
        this.props.history.push("/tripList");
      }
    } else {
      var date = new Date();
      var hours = doubleDigits(date.getHours());
      var minutes = doubleDigits(date.getMinutes());

      this.setState({
        time: hours + ":" + minutes,
      });
    }
  }

  setConfig() {
    this.setState({ config: this.props.tripConfig });
  }

  saveToLocalStorage(data) {
    if (
      !data ||
      (data &&
        (data.name === "Aktuelle Position" || data.name === "Markierter Ort"))
    ) {
      return;
    }
    try {
      let lastSearch = JSON.parse(localStorage.getItem("lastSearch"));
      if (!lastSearch) lastSearch = [];
      let exist = false;

      lastSearch.forEach((search) => {
        // eslint-disable-next-line eqeqeq
        if (search.id == data.id) {
          exist = true;
          return;
        }
      });
      if (!exist) {
        lastSearch.push(data);
        localStorage.setItem("lastSearch", JSON.stringify(lastSearch));
      }
    } catch (e) {}
  }

  saveLastTrip(data) {
    try {
      let lastTrips = JSON.parse(localStorage.getItem("lastTrips"));
      let favoritesTrips = JSON.parse(localStorage.getItem("favoritesTrips"));
      if (!lastTrips) lastTrips = [];
      if (!favoritesTrips) favoritesTrips = [];
      let exist = false;

      lastTrips.forEach((trip) => {
        if (
          trip.origin.id == data.origin.id &&
          trip.destination.id == data.destination.id
        ) {
          exist = true;
          return;
        }
      });
      favoritesTrips.forEach((trip) => {
        if (
          trip.origin.id == data.origin.id &&
          trip.destination.id == data.destination.id
        ) {
          exist = true;
          return;
        }
      });

      if (!exist && data.origin.id !== data.destination.id) {
        if (lastTrips.length >= 5) {
          lastTrips = lastTrips.slice(0, 4);
        }
        lastTrips.unshift(data);
        localStorage.setItem("lastTrips", JSON.stringify(lastTrips));
      }
    } catch (e) {}
  }

  removeLastTrips(id) {
    try {
      let lastTrips = [];
      localStorage.setItem("lastTrips", JSON.stringify(lastTrips));
      this.setState({
        lastTrips: JSON.parse(localStorage.getItem("lastTrips")),
      });
    } catch (e) {}
  }

  requestTrip(force = false) {
    if (this.props.origin != null && this.props.destination != null) {
      if (!this.props.tripTime) {
        let date = new Date();
        let hours = doubleDigits(date.getHours());
        let mins = doubleDigits(date.getMinutes());
        this.setTripTime(hours + ":" + mins);
      }
      if (!this.props.tripDate) {
        let date = new Date();
        let year = date.getUTCFullYear();
        let month = doubleDigits(date.getMonth() + 1);
        let day = doubleDigits(date.getDate());
        this.setTripDate(year + "-" + month + "-" + day);
      }
      console.log(this.props.origin);
      let originID =
        this.props.origin.type == "poi" ||
        this.props.origin.type == "street" ||
        this.props.origin.type == "coord" ||
        this.props.origin.type == "singlehouse"
          ? this.props.origin.id
          : this.props.origin.station
          ? this.props.origin.station.globalID
          : this.props.origin.id;
      let destinationID =
        this.props.destination.type == "poi" ||
        this.props.destination.type == "street" ||
        this.props.destination.type == "coord" ||
        this.props.destination.type == "singlehouse"
          ? this.props.destination.id
          : this.props.destination.station
          ? this.props.destination.station.globalID
          : this.props.destination.id;
      let search =
        originID +
        "-" +
        destinationID +
        "-" +
        this.props.tripDate +
        this.props.tripTime +
        this.props.tripArr;
      if (search !== this.props.lastSearch || force) {
        this.props.setLastSearch(search);
        this.props.resetTripRequest();
        this.saveLastTrip({
          origin: this.props.origin,
          destination: this.props.destination,
        });
        this.props.requestTrip(
          originID,
          destinationID,
          this.props.tripDate,
          this.props.tripTime,
          this.props.tripArr,
          this.props.tripConfig
        );
      }
    }
  }

  render() {
    let counter = 0;
    this.requestTrip();
    return (
      <div className="TripRequest">
        <header>
          <StyledH1 style={{ justifyContent: "space-between" }}>
            Fahrplanauskunft
            <Link to="/config">
              <SettingsIcon style={{ height: "30px" }} />
            </Link>
          </StyledH1>
        </header>
        <div className="flex content">
          <div className="flex address-fields">
            <div className="flex address-inputs">
              <LargeLinkedButton
                buttonLabel={
                  this.props.origin != null ? (
                    <div>
                      <LocationAIcon className="icon-26" />{" "}
                      <div>
                        {this.props.origin.name}
                        {this.props.origin.city
                          ? ", " + this.props.origin.city
                          : null}
                      </div>
                    </div>
                  ) : (
                    <div>Start wählen</div>
                  )
                }
                buttonDestination="/locationFinder"
                func={this.setOrigin}
                detailSite="/tripRequest/"
                titel="Start wählen"
                type="origin"
                showLastTargets={true}
                onlyStops={false}
              />

              <LargeLinkedButton
                buttonLabel={
                  this.props.destination != null ? (
                    <div>
                      <LocationBIcon className="icon-26" />{" "}
                      <div>
                        {this.props.destination.name}
                        {this.props.destination.city
                          ? ", " + this.props.destination.city
                          : null}
                      </div>
                    </div>
                  ) : (
                    <div>Ziel wählen</div>
                  )
                }
                buttonDestination="/locationFinder"
                func={this.setDestination}
                detailSite="/tripRequest/"
                titel="Ziel wählen"
                type="destination"
                showLastTargets={true}
                onlyStops={false}
              />
            </div>
            <div className="flex swap-icon">
              <SwapIcon
                className="icon-30 pointer"
                onClick={() => {
                  if (this.props.destination && this.props.origin) {
                    let _origin = this.props.destination;
                    let _destination = this.props.origin;
                    this.setOrigin(_origin);
                    this.setDestination(_destination);
                  }
                }}
              />
            </div>
          </div>

          <div className="flex timeDate">
            <label htmlFor="date" className="sr-only">
              Datum
            </label>
            <StyledInput
              id="date"
              name="date"
              onChange={(evt) => {
                this.setTripDate(evt.target.value);
              }}
              type="date"
              defaultValue={this.state.date}
            />
            <label htmlFor="time" className="sr-only">
              Zeit
            </label>
            <StyledInput
              id="time"
              name="time"
              onChange={(evt) => {
                this.setTripTime(evt.target.value);
              }}
              type="time"
              defaultValue={this.state.time}
            />
          </div>
          <div className="flex timeDate">
            <div className="switchButton">
              <SmallButton
                buttonLabel="Ab"
                className={`center ${
                  this.props.tripArr === "dep" ? "active" : ""
                }`}
                onClick={() => {
                  this.setTripArr("dep");
                }}
              />
              <SmallButton
                buttonLabel="An"
                className={`center ${
                  this.props.tripArr === "arr" ? "active" : ""
                }`}
                onClick={() => {
                  this.setTripArr("arr");
                }}
              />
            </div>

            <SmallLinkedButton
              disabled={
                this.props.origin
                  ? this.props.destination
                    ? this.props.tripRequest.data
                      ? 0
                      : 1
                    : 1
                  : 1
              }
              onClick={() => {
                this.requestTrip();
              }}
              buttonLabel="Los geht's!"
              buttonDestination="/tripList"
              detailSite="/tripList"
              className="active center bold"
            >
              {this.props.origin &&
              this.props.destination &&
              !this.props.tripRequest.data ? (
                <SpinningCircles
                  height="20px"
                  stroke="#003366"
                  fill="#003366"
                />
              ) : null}
            </SmallLinkedButton>
          </div>
        </div>
        <div className="noSlider flex trips">
          {this.state.lastTrips.length > 0 ||
          this.state.favoritesTrips.length > 0 ? (
            <div>
              <br />
              <div className="flex last-trips">
                Letzte Verbindungen
                <div
                  className="flex center"
                  onClick={() => {
                    this.removeLastTrips();
                  }}
                >
                  <CancleCircleIcon className="icon-30" />
                </div>
              </div>
              {this.state.favoritesTrips.map((item, index) => {
                counter++;
                return (
                  <LastTrip
                    setOrigin={this.setOrigin}
                    setDestination={this.setDestination}
                    trip={item}
                    index={counter}
                    fav={true}
                    key={index}
                  />
                );
              })}
              {this.state.lastTrips.map((item, index) => {
                counter++;
                return (
                  <LastTrip
                    setOrigin={this.setOrigin}
                    setDestination={this.setDestination}
                    trip={item}
                    index={counter}
                    fav={false}
                    key={index}
                  />
                );
              })}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

let mapStateToProps = (state) => {
  return {
    tripRequest: state.tripRequest,
    userPosition: state.userPosition,
    origin: state.originTrip,
    destination: state.destinationTrip,
    tripDate: state.dateTrip,
    tripConfig: state.tripConfig,
    tripTime: state.timeTrip,
    tripArr: state.arrTrip,
    dateTrip: state.dateTrip,
    lastSearch: state.lastSearch,
  };
};

let mapDispatchToProps = {
  setOrigin: setOrigin,
  setDestination: setDestination,
  setTripDate: setTripDate,
  setTripTime: setTripTime,
  setTripArr: setTripArr,
  requestTrip: requestTrip,
  setTrip: setTrip,
  setLastSearch: lastSearch,
  setTripConfig: setTripConfig,
  resetTripRequest: resetTripRequest,
  resetStopRequest: resetStopRequest,
  setUserPosition: setUserPosition,
};
let TripRequestViewPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(TripRequestView);

export default TripRequestViewPage;
